import React from 'react'
import { useNavigate } from 'react-router-dom'
import { BaseView } from '@/components/base'
import { UserCircle, QRCode } from '@/assets/icons'

export const SendHeader: React.FC = () => {
  const navigate = useNavigate()

  const handleProfilePress = () => {
    navigate('/profile/profile-settings', {
      state: { from: '/send-request' },
    })
  }

  const handleQRPress = () => {
    navigate('/share-qr')
  }

  return (
    <BaseView
      row
      align="center"
      justify="space-between"
      p={16}
      px={8}
      data-component="send-header"
    >
      {/* Иконка профиля */}
      <button
        onClick={handleProfilePress}
        className="flex items-center justify-center p-2 rounded-full hover:bg-white/10 transition-colors"
        aria-label="Profile"
      >
        <UserCircle size={32} color="white" />
      </button>

      {/* Иконка QR кода */}
      <button
        onClick={handleQRPress}
        className="flex items-center justify-center p-2 rounded-full hover:bg-white/10 transition-colors"
        aria-label="QR Code"
      >
        <QRCode size={32} color="white" />
      </button>
    </BaseView>
  )
}
